import { useEffect } from "react";

export default function useOnclickOutside(ref, handler) {

    // console.log(ref)
    useEffect(() => {
        function listener(event) {
            // console.log(event);
            
            if (!ref.current || ref.current.contains(event.target)) {
                return
            }

            handler()
        }

        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);

        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        }

    }, [handler, ref])
}
